import React from 'react';
import { Home, ImageOff, FileWarning, Users, DollarSign, Camera } from 'lucide-react';

const CARDS = [
  {
    icon: Home,
    title: 'Twenty deals, one Desktop',
    body:
      'A solo agent has 6 active listings and 14 pending deals. Photos, contracts, disclosures, and signed amendments for all of them land in Downloads or on the Desktop. Finding the "executed addendum for the Cornell listing" means scrolling through 800 files named scan_001 to scan_614.',
  },
  {
    icon: Camera,
    title: 'MLS upload day means renaming every photo',
    body:
      'A shoot returns 460 photos: 180 from a Sony mirrorless, 280 from a DJI Mini drone. DSC_0001 through DSC_0180 and DJI_0001 through DJI_0280. The MLS rejects DSC_xxxx; you need property-prefixed filenames before uploading. Manual rename is a wasted afternoon.',
  },
  {
    icon: FileWarning,
    title: 'Disclosures filed under the wrong property',
    body:
      'You have three active "Smith" deals: a buyer, a seller, and a referral. A Lead Based Paint disclosure gets filed under the wrong Smith. At closing the title company asks for it and you spend twenty minutes hunting before you find it under another deal.',
  },
  {
    icon: Users,
    title: 'Transaction coordinator hand-offs lose context',
    body:
      'A TC manages 30 active transactions across multiple agents. Each agent has their own filing pattern. The TC tries to standardize, but every Monday the new files arrive named with the agent\'s personal convention. Reconciling that into a clean broker-ready folder is a part-time job.',
  },
  {
    icon: DollarSign,
    title: 'Commission docs and 1099s lost at year end',
    body:
      'Broker 1099, commission statements, referral payouts, license renewal receipts. They all live in the same Inbox as the deal documents. Come tax time, you pull together a folder for your CPA from across twenty deal folders and three unrelated downloads.',
  },
  {
    icon: ImageOff,
    title: 'Drone vs interior, agent vs photographer',
    body:
      'Photo set has aerials, dusk exteriors, interiors from two photographers, and your own iPhone shots for the buyer presentation. The MLS wants the photographer set sized for upload; the buyer presentation wants a curated 20. Splitting these by hand is an hour per listing.',
  },
];

const PainPoints = () => {
  return (
    <section id="problem" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          The real estate filing problem
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Six patterns we hear from solo agents, transaction coordinators, and small brokerages.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {CARDS.map((card, i) => {
          const Icon = card.icon;
          return (
            <div key={i} className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6">
              <div className="w-10 h-10 rounded-full bg-sortio-secondary/15 border border-sortio-secondary/30 flex items-center justify-center mb-4">
                <Icon className="text-sortio-secondary" size={18} />
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-3">{card.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{card.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default PainPoints;
